import request from '@/utils/request';
import { appId } from '@/utils/auth'
export function verifySsoToken(token) {
    return request({
      url: '/admin/verifySsoToken?token='+token+'&appId='+appId(),
      method: 'get'
    })
  }


// WEBPACK FOOTER //
// ./src/api/loginBySSO.js